import { Helmet } from 'react-helmet'

export function InsuranceHead({ insurance }) {
  if (!insurance) {
    return null
  }

  if (insurance?.insuranceProvider === 'Teak') {
    return (
      <Helmet>
        <script>
          {`
          (function(w,d,c,n,s,p){
            w[n] = w[n] || function () { (w[n].q = w[n].q || []).push(arguments) }, w[n].l = +new Date();
            s = d.createElement(c), p = d.getElementsByTagName(c)[0];
            s.async = s.src = 'https://icw.protecht.com/client-widget.min.js?v=4';
            p.parentNode.insertBefore(s, p);
          })(window,document,'script','tg');
        `}
        </script>
      </Helmet>
    )
  }

  return null
}
